import { useCallback, useEffect, useState } from 'react';
import { Location } from 'history';
import { matchPath, Prompt, useHistory } from 'react-router-dom';
import UnsavedChangesModal from 'Organisms/UnsavedChangesModal/UnsavedChangesModal';

type Props = {
  hasChanges: boolean;
  allowedPaths?: string[];
  title?: string;
  message?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
};

const UnsavedChangesPrompt = ({
  hasChanges,
  allowedPaths,
  title,
  message,
  confirmButtonText,
  cancelButtonText,
}: Props) => {
  const history = useHistory();
  const [newUrl, setNewUrl] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [canLeave, setCanLeave] = useState<boolean>(false);

  const beforeLeaving = useCallback(
    (location: Location) => {
      if (allowedPaths?.length) {
        const isAllowedPath = !!matchPath(location.pathname, {
          path: [...allowedPaths],
          exact: true,
        });

        if (isAllowedPath) {
          return true;
        }
      }

      if (!canLeave) {
        setIsModalOpen(true);
        setNewUrl(location.pathname.concat(location.search));
      }

      return canLeave;
    },
    [canLeave, allowedPaths]
  );

  useEffect(() => {
    if (canLeave) {
      history.push(newUrl);
    }
  }, [canLeave, history, newUrl]);

  return (
    <>
      <Prompt when={hasChanges} message={beforeLeaving} />
      <UnsavedChangesModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        onConfirm={() => setCanLeave(true)}
        overlayClassName='z-50'
        title={title}
        message={message}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
      />
    </>
  );
};

export default UnsavedChangesPrompt;
